export const EMPTY_STATE_IMAGE = {
	noResults: 'assets/images/no-results.svg',
};
